// extracted by mini-css-extract-plugin
export var messageSideLeft = "_jl-1";
export var messageSideRight = "_jl-2";
export var orderLookupBubbleContainer = "_jl-0";
export var submitButton = "_jl-3";